import { css } from 'astroturf';
import { Link } from 'gatsby';
import React from 'react';

const styles = css`
  .activeMenu {
    color: #000;
    background: none;
  }
  .activeMenu::before {
    content: '•';
    position: absolute;
    right: calc(100% + 4px);
  }
  .sideList a {
    margin-left: 0.5rem;
    font-weight: 400;
  }
`;

class DocsListing extends React.Component {
  render() {
    return (
      <ul className={['sideList', styles.sideList].join(' ')}>
        <li>
          <h4>Getting started</h4>
        </li>
        <li>
          <Link to="/docs/" activeClassName={styles.activeMenu}>
            Quick Start
          </Link>
        </li>
        <li>
          <Link to="/docs/setup/" activeClassName={styles.activeMenu}>
            Setup instructions
          </Link>
        </li>
        <li>
          <Link to="/docs/switching-to-polypane/" activeClassName={styles.activeMenu}>
            Switching to Polypane
          </Link>
        </li>

        <li>
          <Link to="/docs/ui-overview/" activeClassName={styles.activeMenu}>
            UI overview
          </Link>
        </li>
        <li>
          <Link to="/docs/customizing-polypane/" activeClassName={styles.activeMenu}>
            Customizing Polypane
          </Link>
        </li>
        <li>
          <Link to="/docs/list-of-shortcuts/" activeClassName={styles.activeMenu}>
            Shortcuts
          </Link>
        </li>
        <li>
          <Link to="/docs/helper-extension-for-other-browsers/" activeClassName={styles.activeMenu}>
            Helper for other browsers
          </Link>
        </li>

        <li>
          <h4>Core concepts</h4>
        </li>
        <li>
          <Link to="/docs/projects/" activeClassName={styles.activeMenu}>
            Projects
          </Link>
        </li>

        <li>
          <Link to="/docs/workspaces/" activeClassName={styles.activeMenu}>
            Workspaces
          </Link>
        </li>
        <li>
          <Link to="/docs/layouts/" activeClassName={styles.activeMenu}>
            Layouts
          </Link>
        </li>

        <li>
          <Link to="/docs/portal/" activeClassName={styles.activeMenu}>
            Portal
          </Link>
        </li>
        <li>
          <Link to="/docs/playgrounds/" activeClassName={styles.activeMenu}>
            Playgrounds
          </Link>
        </li>

        <li>
          <Link to="/docs/command-bar/" activeClassName={styles.activeMenu}>
            Command bar
          </Link>
        </li>
        <li>
          <Link to="/docs/session-management/" activeClassName={styles.activeMenu}>
            Session management
          </Link>
        </li>

        <li>
          <Link to="/docs/accessibility-overview/" activeClassName={styles.activeMenu}>
            Accessibility overview
          </Link>
        </li>

        <li>
          <h4>Browser features</h4>
        </li>

        <li>
          <Link to="/docs/browser-features/" activeClassName={styles.activeMenu}>
            Browser features overview
          </Link>
        </li>
        <li>
          <Link to="/docs/tab-customization/" activeClassName={styles.activeMenu}>
            Tab customization
          </Link>
        </li>
        <li>
          <Link to="/docs/dark-and-light-mode/" activeClassName={styles.activeMenu}>
            Dark and light mode
          </Link>
        </li>
        <li>
          <Link to="/docs/global-zoom/" activeClassName={styles.activeMenu}>
            Global zoom
          </Link>
        </li>
        <li>
          <Link to="/docs/browser-extensions/" activeClassName={styles.activeMenu}>
            Browser extensions
          </Link>
        </li>

        <li>
          <h4>Panes</h4>
        </li>
        <li>
          <Link to="/docs/intro-to-panes/" activeClassName={styles.activeMenu}>
            Intro to panes
          </Link>
        </li>
        <li>
          <Link to="/docs/pane-management/" activeClassName={styles.activeMenu}>
            Manage panes
          </Link>
        </li>
        <li>
          <Link to="/docs/pane-sizes/" activeClassName={styles.activeMenu}>
            Sizing panes
          </Link>
        </li>
        <li>
          <Link to="/docs/synced-interactions/" activeClassName={styles.activeMenu}>
            Synced interactions
          </Link>
        </li>
        <li>
          <Link to="/docs/showing-multiple-urls/" activeClassName={styles.activeMenu}>
            Showing multiple URLs
          </Link>
        </li>
        <li>
          <Link to="/docs/device-presets/" activeClassName={styles.activeMenu}>
            Device presets
          </Link>
        </li>
        <li>
          <Link to="/docs/emulation/" activeClassName={styles.activeMenu}>
            Emulation
          </Link>
        </li>

        <li>
          <Link to="/docs/breakpoints/" activeClassName={styles.activeMenu}>
            CSS Media Breakpoints
          </Link>
        </li>
        <li>
          <Link to="/docs/web-vitals/" activeClassName={styles.activeMenu}>
            Web Vitals
          </Link>
        </li>
        <li>
          <Link to="/docs/horizontal-overflow/" activeClassName={styles.activeMenu}>
            Horizontal Overflow detection
          </Link>
        </li>

        <li>
          <h4>Devtools</h4>
        </li>
        <li>
          <Link to="/docs/polypane-peek/" activeClassName={styles.activeMenu}>
            Polypane Peek
          </Link>
        </li>
        <li>
          <Link to="/docs/making-screenshots/" activeClassName={styles.activeMenu}>
            Screenshots
          </Link>
        </li>
        <li>
          <Link to="/docs/recording/" activeClassName={styles.activeMenu}>
            Video Recording
          </Link>
        </li>
        <li>
          <Link to="/docs/developer-tools/" activeClassName={styles.activeMenu}>
            Chromium &amp; Polypane Devtools
          </Link>
        </li>
        <li>
          <Link to="/docs/layout-debugging/" activeClassName={styles.activeMenu}>
            Layout debugging
          </Link>
        </li>
        <li>
          <Link to="/docs/rulers-grids-and-guides/" activeClassName={styles.activeMenu}>
            Rulers, grids and guides
          </Link>
        </li>
        <li>
          <Link to="/docs/image-overlay/" activeClassName={styles.activeMenu}>
            Image overlay
          </Link>
        </li>
        <li>
          <Link to="/docs/debug-overlays/" activeClassName={styles.activeMenu}>
            Debug overlays
          </Link>
        </li>
        <li>
          <Link to="/docs/simulators/" activeClassName={styles.activeMenu}>
            Simulators
          </Link>
        </li>
        <li>
          <Link to="/docs/find-elements/" activeClassName={styles.activeMenu}>
            Find elements
          </Link>
        </li>

        <li>
          <Link to="/docs/measure-text-length/" activeClassName={styles.activeMenu}>
            Measure text length
          </Link>
        </li>
        <li>
          <Link to="/docs/color-picker/" activeClassName={styles.activeMenu}>
            Color Picker
          </Link>
        </li>
        <li>
          <Link to="/docs/json-and-xml-viewer/" activeClassName={styles.activeMenu}>
            JSON and XML viewer
          </Link>
        </li>
        <li>
          <Link to="/docs/form-autofill/" activeClassName={styles.activeMenu}>
            Form Autofill
          </Link>
        </li>

        <li>
          <Link to="/docs/live-auto-reloading/" activeClassName={styles.activeMenu}>
            Live reloading
          </Link>
        </li>

        <li>
          <Link to="/docs/reload-css/" activeClassName={styles.activeMenu}>
            Reload CSS
          </Link>
        </li>

        <li>
          <Link to="/docs/link/" activeClassName={styles.activeMenu}>
            Share panel
          </Link>
        </li>

        <li>
          <h4>Integrations</h4>
        </li>
        <li>
          <Link to="/docs/integrations/" activeClassName={styles.activeMenu}>
            Integrations
          </Link>
        </li>
        <li>
          <Link to="/docs/mcp-server/" activeClassName={styles.activeMenu}>
            MCP server
          </Link>
        </li>

        <li>
          <Link to="/docs/message-bus/" activeClassName={styles.activeMenu}>
            Message Bus
          </Link>
        </li>
        <li>
          <Link to="/docs/other-tools/" activeClassName={styles.activeMenu}>
            Local servers support
          </Link>
        </li>

        <li>
          <h4>Side panels</h4>
        </li>
        <li>
          <Link to="/docs/intro-to-panel/" activeClassName={styles.activeMenu}>
            Intro to panel
          </Link>
        </li>
        <li>
          <Link to="/docs/meta-information/" activeClassName={styles.activeMenu}>
            Meta
          </Link>
        </li>
        <li>
          <Link to="/docs/elements-panel/" activeClassName={styles.activeMenu}>
            Elements
          </Link>
        </li>
        <li>
          <Link to="/docs/console/" activeClassName={styles.activeMenu}>
            Console
          </Link>
        </li>
        <li>
          <Link to="/docs/network-panel/" activeClassName={styles.activeMenu}>
            Network
          </Link>
        </li>
        <li>
          <Link to="/docs/outline-panel/" activeClassName={styles.activeMenu}>
            Outline
          </Link>
        </li>
        <li>
          <Link to="/docs/browse/" activeClassName={styles.activeMenu}>
            Browse
          </Link>
        </li>
        <li>
          <Link to="/docs/workspace-management/" activeClassName={styles.activeMenu}>
            Workspaces
          </Link>
        </li>

        <li>
          <Link to="/docs/snippets/" activeClassName={styles.activeMenu}>
            Snippets
          </Link>
        </li>

        <li>
          <Link to="/docs/accessibility-panel/" activeClassName={styles.activeMenu}>
            Accessibility
          </Link>
        </li>
        <li>
          <Link to="/docs/storage-panel/" activeClassName={styles.activeMenu}>
            Storage
          </Link>
        </li>
        <li>
          <Link to="/docs/source-panel/" activeClassName={styles.activeMenu}>
            Source
          </Link>
        </li>
        <li>
          <Link to="/docs/devtools-panel/" activeClassName={styles.activeMenu}>
            Chromium Devtools panel
          </Link>
        </li>

        <li>
          <h4>Workflows</h4>
        </li>
        <li>
          <Link to="/docs/responsive-debugging-workflow/" activeClassName={styles.activeMenu}>
            Responsive debugging
          </Link>
        </li>
        <li>
          <Link to="/docs/accessibility-audit-workflow/" activeClassName={styles.activeMenu}>
            Accessibility audit
          </Link>
        </li>
        <li>
          <Link to="/docs/social-card-and-open-graph-workflow/" activeClassName={styles.activeMenu}>
            Social card and Open Graph
          </Link>
        </li>
        <li>
          <Link to="/docs/team-workflows/" activeClassName={styles.activeMenu}>
            Team workflows
          </Link>
        </li>

        <li>
          <h4>Troubleshooting</h4>
        </li>
        <li>
          <Link to="/docs/mental-model/" activeClassName={styles.activeMenu}>
            Mental model of browser contexts
          </Link>
        </li>
        <li>
          <Link to="/docs/website-issues-you-could-encounter/" activeClassName={styles.activeMenu}>
            Site issues
          </Link>
        </li>
        <li>
          <Link to="/docs/detecting-polypane/" activeClassName={styles.activeMenu}>
            Detecting Polypane
          </Link>
        </li>
        <li>
          <Link to="/docs/security/" activeClassName={styles.activeMenu}>
            Security
          </Link>
        </li>
        <li>
          <Link to="/docs/performance/" activeClassName={styles.activeMenu}>
            Performance
          </Link>
        </li>
        <li>
          <Link to="/docs/known-issues/" activeClassName={styles.activeMenu}>
            Known issues
          </Link>
        </li>

        <li>
          <h4>Reference</h4>
        </li>
        <li>
          <Link to="/docs/faq/" activeClassName={styles.activeMenu}>
            FAQ
          </Link>
        </li>
        <li>
          <Link to="/docs/command-line-options/" activeClassName={styles.activeMenu}>
            Command line options (CLI)
          </Link>
        </li>
        <li>
          <Link to="/docs/experimental-chromium-features/" activeClassName={styles.activeMenu}>
            Experimental Chromium features
          </Link>
        </li>
        <li>
          <Link to="/docs/changelog/" activeClassName={styles.activeMenu}>
            Changelog
          </Link>
        </li>

        <li>
          <h4>For teams &amp; organizations</h4>
        </li>
        <li>
          <Link to="/docs/pitching-polypane/" activeClassName={styles.activeMenu}>
            Pitching Polypane to your team
          </Link>
        </li>
        <li>
          <Link to="/docs/review-and-approval-by-it-and-security/" activeClassName={styles.activeMenu}>
            Info for IT and Security teams
          </Link>
        </li>
        <li>
          <Link to="/docs/sales-and-procurement/" activeClassName={styles.activeMenu}>
            Info for Sales and Procurement
          </Link>
        </li>
      </ul>
    );
  }
}

export default DocsListing;
